
import {
  IEditorRegistry,
  IEditorDescriptor,
  IEditorInput,
  IEditorInputTypeName,
} from '@workbench-stack/core';
import { isArray } from '@vscode-alt/monaco-editor/esm/vs/base/common/types';
import { Registry } from '@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform';
import { ClientExtensions } from '../constants';

const INPUT_DESCRIPTORS_PROPERTY = '__$inputDescriptors';

class EditorRegistry implements IEditorRegistry {
  private editors: IEditorDescriptor[] = [];

  public registerEditor(
    descriptor: IEditorDescriptor,
    editorInputDescriptor: IEditorInputTypeName,
  ): void;
  public registerEditor(
    descriptor: IEditorDescriptor,
    editorInputDescriptor: IEditorInputTypeName[],
  ): void;
  public registerEditor(
    descriptor: IEditorDescriptor,
    editorInputDescriptor: IEditorInputTypeName | IEditorInputTypeName[],
  ) {
    // Support both non-array and array parameter
    let inputDescriptors: string[] = [];
    if (!isArray(editorInputDescriptor)) {
      inputDescriptors.push(editorInputDescriptor.__typename);
    } else {
      inputDescriptors = editorInputDescriptor.map(ed => ed.__typename);
    }

    descriptor[INPUT_DESCRIPTORS_PROPERTY] = inputDescriptors;
    this.editors.push(descriptor);
  }

  public getEditor(input: IEditorInputTypeName): IEditorDescriptor | null {
    const findEditorDescriptors = (
      // tslint:disable-next-line:no-shadowed-variable
      input: IEditorInputTypeName,
    ): IEditorDescriptor[] => {
      const matchingDescriptors: IEditorDescriptor[] = [];

      for (const editor of this.editors) {
        const inputDescriptors: string[] = editor[INPUT_DESCRIPTORS_PROPERTY];
        for (const inputDescriptor of inputDescriptors) {
          // Direct check
          if(input.typeId) {
            if (inputDescriptor === input.typeId) {
              matchingDescriptors.push(editor);
              break;
            }
          }
          // fallback to `__typename`
          if (inputDescriptor === input.__typename) {
            matchingDescriptors.push(editor);
            break;
          }
        }
      }
      return matchingDescriptors;
    };

    const descriptors = findEditorDescriptors(input);
    if (descriptors && descriptors.length > 0) {
      // Ask the input for its preferred Editor
      const filteredDescriptors = descriptors.filter(pref => pref.id === input.preferredEditorId);
      if(filteredDescriptors && filteredDescriptors.length > 0) {
        return filteredDescriptors[0];
      }
      // todo
      // make graphql call
      console.log(' To be worked');
    }

    // Otherwise, first come first serve
    return descriptors[0];
  }

  public getEditorById(editorId: string): IEditorDescriptor | null {
    for (const editor of this.editors) {
      if (editor.id === editorId) {
        return editor;
      }
    }

    return null;
  }

  public getEditors(): IEditorDescriptor[] {
    return this.editors.slice(0);
  }
}


Registry.add(ClientExtensions.Editors, new EditorRegistry());

